import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

interface NavLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function NavLink({ href, children, className, onClick }: NavLinkProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    // Handle hash links (e.g., /#services)
    if (href.includes("#")) {
      e.preventDefault();
      const [path, hash] = href.split("#");
      
      if (location.pathname === "/" || path === "" || path === "/") {
        // Already on home page, just scroll to section
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        // Navigate to home page then scroll after a delay
        navigate("/");
        // Wait for navigation and page render, then scroll
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 150);
      }
      onClick?.();
      return;
    }

    onClick?.();
  };

  // For regular page links
  if (!href.includes("#")) {
    return (
      <Link
        to={href}
        className={cn(
          "text-white hover:text-secondary transition-colors font-semibold",
          className
        )}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  // For hash links
  return (
    <a
      href={href}
        className={cn(
          "text-white hover:text-secondary transition-colors font-semibold",
        className
      )}
      onClick={handleClick}
    >
      {children}
    </a>
  );
}
